import React from 'react'
import MilitaryPayCalculator from '../components/MilitaryPayCalculator'

const MilitaryCalculatorPage = () => {
  return (
    <div className="bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        {/* SEO-Optimized Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Military Paycheck Calculator
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Calculate your military take home pay with our army pay calc tool. Get accurate estimates for active duty, reserve, and national guard personnel including base pay, BAH, BAS, and tax withholdings.
          </p>
        </div>

        {/* Calculator Component */}
        <MilitaryPayCalculator />

        {/* SEO Content Section */}
        <div className="max-w-4xl mx-auto mt-16 space-y-8">
          <section>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              How the Military Pay Calculator Works
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Our military paycheck calculator provides accurate estimates for service members across all branches including Army, Navy, Air Force, Marines, Coast Guard, and Space Force. The calculator accounts for base pay based on rank and years of service, plus common allowances like Basic Allowance for Housing (BAH) and Basic Allowance for Subsistence (BAS).
            </p>
            <p className="text-gray-700 leading-relaxed">
              Military pay is subject to federal income tax, but allowances (BAH and BAS) are tax-free. Our calculator accurately separates taxable and non-taxable income to provide you with a precise take home pay estimate.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Understanding Military Allowances
            </h2>
            <div className="bg-white rounded-lg shadow p-6 space-y-4">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Basic Allowance for Housing (BAH)</h3>
                <p className="text-gray-700">
                  BAH is a non-taxable allowance that helps service members cover housing costs. The amount varies by duty location, pay grade, and whether you have dependents. BAH is not subject to federal income tax.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Basic Allowance for Subsistence (BAS)</h3>
                <p className="text-gray-700">
                  BAS is a non-taxable allowance intended to offset the cost of meals. All enlisted and officer service members receive BAS, and the amount is set by the Department of Defense.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Military Tax Considerations
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Service members pay federal income tax on base pay but not on allowances. State income tax varies by state - some states offer full exemptions for military pay, while others provide partial exemptions or no special treatment. Military members deployed to combat zones may receive additional tax benefits.
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default MilitaryCalculatorPage
